import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RepositoryStatsService {

  private api = '/server/api/discover/search/objects';

  constructor(private http: HttpClient) {}

  private count(query: string): Observable<number> {
    return this.http.get<any>(`${this.api}?query=${query}&size=1`)
      .pipe(map(res => res?.page?.totalElements || 0));
  }

  getStats(): Observable<any> {

    return forkJoin({
      researchPapers: this.count(
        'dc.type:("Article" OR "Conference Paper" OR "Research Paper")'
      ),

      theses: this.count(
        'dc.type:("Thesis" OR "Dissertation")'
      ),

      journals: this.count(
        'dc.type:("Journal Article")'
      ),

      communities: this.http.get<any>('/server/api/core/communities?size=1')
        .pipe(map(res => res?.page?.totalElements || 0))
    });
  }
}
